import React from "react";

// Contenu du tutoriel de l'écran "Mails" — étapes (image + titre +
// description) affichées par le composant générique TutorialOverlay
// (src/components/ui/TutorialOverlay.js). "image" est volontairement vide
// pour l'instant : captures d'écran à ajouter ensuite, slide par slide.
const mailsTutorial = [
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20140254.png",
    title: "Bienvenue dans Mails",
    legende: "",
    description: (
      <>
        Cet écran connecte votre boîte <strong>Gmail</strong> à MyAlfa :
        vous consultez vos messages, répondez et en envoyez de nouveaux,
        sans changer d'écran.
        <br />
        <br />
        Chaque mail reçoit automatiquement un{" "}
        <strong>badge de catégorie</strong> (Compta / fiscal, Social,
        Juridique, Demande de rdv...) et, si besoin, un badge{" "}
        <strong>« Prioritaire »</strong>. Utilisez la recherche ou les
        catégories pour filtrer la liste.
      </>
    ),
  },
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20140312.png",
    title: "Les actions possibles sur un mail",
    legende: "",
    description: (
      <>
        <strong>Rattachez un dossier client</strong> en haut du mail —
        nécessaire pour le classer ou le transformer en tâche / mission.
        <br />
        <br />
        <strong>Répondre</strong> / <strong>Transférer</strong> envoient
        directement depuis Gmail ; <strong>Classer &amp; archiver</strong>{" "}
        retire le mail de la liste (toujours visible dans Gmail) ;{" "}
        <strong>En tâche</strong> / <strong>En mission ponctuelle</strong>{" "}
        signalent un suivi à faire.
        <br />
        <br />
        Un numéro de téléphone détecté propose de l'ajouter à la fiche du
        dossier, et <strong>« Nouveau mail »</strong> ouvre un formulaire
        d'envoi avec des modèles prêts à l'emploi.
      </>
    ),
  },
];

export default mailsTutorial;
